'use strict';
(function($){
	/*
	 * Vetology.Vetology widget
	 *
	 * @description This ios the main Vetology widget to load the tools needed in the page
	 *				By the time this plugin runs, all othrs should have already been loaded, so this should be the last script to be loaded;
	 *
	 * @options					See description for each option
	 *
	 * @method	See description above each method
	 */
	$.widget(
		'Vetology.Vetology',
		{
			"options": {
				"load_widgets": {
					"PatientSwissKnife": {
						"init": true,
						"options": {}
					},
					"Sidebars": {
						"init": true,
						"options": {}
					},
					"SidebarsMenu": {
						"init": true,
						"options": {}
					},
					"Ratings": {
						"triggerOn": ".rating_block",
						"init": true,
						"options": {}
					},
					"ProgressAnimation": {
						"triggerOn": ".radial-holder",
						"init": true,
						"options": {}
					},
					"NewCase": {
						"init": true,
						"options": {}
					},
					"AutoComplete": {
						"init": true,
						"options": {}
					},
					"CaseLink": {
						"init": true,
						"options": {}
					},
					"Filters": {
						"init": true,
						"options": {}
					},
					"PlatformControls": {
						"init": true,
						"options": {}
					},
					"Navigation": {
						"init": true,
						"options": {}
					},
					"Commutation": {
						"init": true,
						"options": {}
					},
                    "Chat": {
                        "init": true,
                        "options": {}
                    },
					"ImageHandler": {
						"init": true,
						"options": {}
					},
					"ServerMonitor": {
						"init": true,
						"options": {}
					},
					"AISettings": {
						"init": true,
						"options": {}
					},
					"Tutorials": {
						"init": true,
						"options": {}
					},
					"Worklist": {
						"init": true,
						"options": {}
					},
					"LionManager": {
						"init": true,
						"options": {}
					},
					"FormHelper": {
						"init": true,
						"options": {}
					},
					"VetologyAdmin": {
						"init": true,
						"options": {}
					},
					"FlipBook": {
						"init": true,
						"options": {}
					},
					"OneClickReferral": {
						"init": true,
						"options": {}
					},
					"VetologyReports": {
						"init": true,
						"options": {}
					},
					"Store": {
						"init": true,
						"options": {}
					},
					"UserProfileManager": {
						"init": true,
						"options": {}
					},
					"gmap": {
						"init": $('.geoMap').length > 0,
						"options": {},
						"onInit": function(){
							$('body').gmap('setupMaps');
							$('body').on('click', '.joinNetworkCSH', function(e){
								e.preventDefault();
							});
						}
					},
					"GTranslate": {
						"triggerOn": "#google_translate_element",
						"init": true,
						"options": {}
					},
					"SubNationalDivision": {
						"init": true,
						"options": {}
					},
					"FullTextSearch": {
					    init: true,
                        "options": {}
                    },
					"Ajax": {
                        "init": true,
                        "options": {}
                    },
					"SignUpWizard": {
                        "init": true,
                        "options": {}
                    },
                    "AskAimeQuestion": {
					    init: true,
                        "options": {}
                    },
					"EmailEvents": {
						"init": true,
						"options": {}
					},
                    "CronMonitor": {
					    init: true,
                        options: {}
                    },
					"LogServerList": {
						init: true,
						options: {}
					},
					"ViewLogs": {
						init: true,
						options: {}
					},
					"GooglePlacesSubmission": {
						init: true,
						options: {}
					},
					"FormatNumberPhone": {
                        "init": true,
                        "options": {}
                    },
				},
				"intantiatedEs6Classes": {

				},
				"pageTitle": {
					"sequence": ["✴", "✷", "✶", "✸", "✹", "✺", "❁", "❂", "❁", "✺", "✹", "✶", "✷", "✴"],
					"index": 0,
					"interval": null
				},
				"doingAjax": false,
				"nonconformanceNag": false
			},
			/*
			 * Vetology.Vetology._init
			 *
			 * @description	Initializes the Vetology Platform
			 *
			 * @return NULL
			 *
			 */
			"_init": function(){
				var o = this;
				var dev = $("body").data("dev");
				o.options.dev = typeof dev !== "undefined" && dev == '1';
				if(Modernizr.touch){
					alert("mobile jq loaded");
					$.getScript("https://ajax.googleapis.com/ajax/libs/jquerymobile/1.4.5/jquery.mobile.min.js");
				}
				/*console.info("Platform running on version " + $.fn.jquery + " of $ and " + $.ui.version + " of ui");*/
				$.ajaxPrefilter(function(options, originalOptions, xhr) { // this will run before each request
					var token = $('meta[name="csrf-token"]').attr('content'); // or _token, whichever you are using
					if (token) {
						return xhr.setRequestHeader('X-CSRF-TOKEN', token); // adds directly to the XmlHttpRequest Object
					}
				});
				o.options.pageTitle.title = window.document.title;
				$("body").removeClass("load_pending");
				o._setDoubleScroll();
				o._setTimers();
				o._loadTriggers();
				o._loadWidgets();
				o._loadVendorWidgets();
				o._initDOMElements();
				if($(".recoveryForm").length > 0){
					$(".recoveryForm").removeClass("hide");
				} else if($(".loginForm").length > 0){
					$(".loginForm").removeClass("hide");
				}
				o._checkNonconformance();
			},
			/*
			 * Vetology.Vetology._initDOMElements
			 *
			 * @description	Initializes the loaded elements according to the needs
			 *
			 * @return NULL
			 *
			 */
			/*
			 * vetology.platform.do
			 *
			 * @description		Triggers the called method.
			 *
			 * @param	mixed 	parameters	The pssed parameters
			 *
			 * @return	mixed	Depending on the method called
			 *
			 */
			do	: function(parameters){
				var a = parameters;
				if(typeof this['_' + a[0]] == "undefined"){
					console.error("Migration missing for ", a[0]);
					return;
				}
				switch(a.length){
					case 1:
						return this['_' + a[0]]();
					case 2:
						return this['_' + a[0]](a[1]);
					case 3:
						return this['_' + a[0]](a[1], a[2]);
					case 4:
						return this['_' + a[0]](a[1], a[2], a[3]);
					case 5:
						return this['_' + a[0]](a[1], a[2], a[3], a[4]);
					case 6:
						return this['_' + a[0]](a[1], a[2], a[3], a[4], a[5]);
					case 7:
						return this['_' + a[0]](a[1], a[2], a[3], a[4], a[5], a[6]);
				}
			},
			/*
			 * vetology.platform._echoSuccess
			 *
			 * @description	Processes an echo
			 *
			 * @param String google_place_id	The google_place_id related to the marker
			 *
			 * @return NULL
			 *
			 */
			_echoSuccess	: function(lion_id){
				$('.sendEcho[data-id="' + lion_id + '"]').attr('class', 'sendEcho btn btn-flat btn-xs btn-success').html('Echo success');
				$('.closeLion[data-id="' + lion_id + '"]').removeClass('hide');
				setTimeout(
					function(){
						$('.sendEcho[data-id="' + lion_id + '"]').attr('class', 'sendEcho btn btn-flat btn-xs btn-warning').html('SendEcho');
						$('.closeLion[data-id="' + lion_id + '"]').addClass('hide');
					},
					10000
				);
			},
			_redrawAnalytics: function(){
				if(typeof this.options.map != 'undefined'){
					this.options.map.initAnalytics();
				}
			},
			/*
			 * vetology.platform._doPopTitle
			 *
			 * @description	Enable popover titles for all elements
			 *
			 * @return NULL
			 *
			 */
			_doPopTitle	: function(){
				var o = this;
				$("body").on("click mouseenter", ".doPop", function(e){
					var el = $(this);
					if(el.closest(".clinicMarkerLabel").length > 0){
						if(typeof el.closest(".clinicMarkerLabel").data("bs.popover") === "undefined"){
							var popWhere = el.data('toggle') == 'popinfo' ? 'auto' : 'bottom';
							el.closest(".clinicMarkerLabel").popover(
								{
									'trigger'	: 'hover focus',
									'placement'	: popWhere,
									'content'	: el.data("content"),
									'title'	: el.attr("title"),
									'html'		: true,
									'container'	: 'body'
								}
							).popover('show');
						}
					} else {
						if(typeof el.data('withPop') === "undefined"){
							var popWhere = el.data('toggle') == 'popinfo' ? 'auto' : 'bottom';
							el.data('withPop', true);
							el.popover(
								{
									'trigger'	: 'hover focus',
									'placement'	: popWhere,
									'html'		: true,
									'container'	: 'body'
								}
							).popover('show');
						}
					}
				});
			},
			_showPromptDialog: function(title, message, callback){
				var o = this;
				var button = typeof callback == "function" ? $("<button class='callback_triggered callback_triggered btn btn-sm btn-primary'>Continue</button>") : "";
				o.options.modal.find(".modal-title").html(title);
				o.options.modal.find(".modal-body").html(message);
				o.options.modal.find(".modal-dialog").attr("class", "modal-dialog modal-lg");
				o.options.modal.removeClass("modal-danger modal-success modal-warning modal-info alert-danger alert-success alert-warning alert-info");
				o.options.modal.addClass((typeof o.options.modal.data("base") != "undefined" ? o.options.modal.data("base") : "alert") + "-info");
				o.options.modal.modal("show");
				o.options.modal.on('hidden.bs.modal', function () {
					o.options.modal.find(".modal-body").html("");
				});
				if(typeof callback == "function"){
					o.options.modal.find(".modal-body").append('<br>').append(button);
					button.on("click", function(){
						var data = {};
						o.options.modal.find('input').each(function(){
							var el = $(this);
							data[el.attr('name')] = el.val();
						});
						o.options.modal.find('textarea').each(function(){
							var el = $(this);
							data[el.attr('name')] = el.val();
						});
						o.options.modal.find('select').each(function(){
							var el = $(this);
							data[el.attr('name')] = el.val();
						});
						callback(data);
					});
				}
			},
			triggerHtmlEvent: function(element, eventName){
				var event;
				if(document.createEvent) {
					event = document.createEvent('HTMLEvents');
					event.initEvent(eventName, true, true);
					element.dispatchEvent(event);
				} else {
					event = document.createEventObject();
					event.eventType = eventName;
					element.fireEvent('on' + event.eventType, event);
				}
			},
			_initDOMElements: function(){
				var o = this;
				/*CK Editors*/
				if(typeof window.ckeditorready == "undefined"){
					window.ckeditorready = false;
					$.getScript("https://cdn.ckeditor.com/4.9.2/full-all/ckeditor.js", function(data, textStatus, jqxhr){
						$.getScript("/vetology_asset/js_vendor/Vetology/CKEditor/Plugins/FileManager/plugin.js", function(data, textStatus, jqxhr){
							CKEDITOR.editorConfig = function(config) {
								config.allowedContent = true;
								config.removeFormatAttributes = '';
							}
							window.ckeditorready = true;
						});
					});
					
				}
				var widgetize = $(".make_ck:not(.vetology_widget_loaded)");
				$.each(widgetize, function(i, el){
					el = $(el);
					var cki = setInterval(
						function(){
							if(window.ckeditorready){
								clearInterval(cki);
								CKEDITOR.replace(
									el.attr("id"),
									{
										height: 300,
										extraPlugins: 'filemanager',
										allowedContent: true,
										removeFormatAttributes: ''
									}
								);
							}
						}, 100
					);
					el.addClass("vetology_widget_loaded");
				});
				/*Sortables*/
				var widgetize = $(".make_sortable:not(.vetology_widget_loaded)");
				$.each(widgetize, function(i, el){
					el = $(el);
					if(el.find(".sort_handle").length > 0){
						el.addClass("vetology_widget_loaded").sortable({handle: ".sort_handle"});
					} else {
						el.addClass("vetology_widget_loaded").sortable();
					}
				});
				/*select togglers*/
				var widgetize = $(".selector_toggler:not(.vetology_widget_loaded)");
				$.each(widgetize, function(i, el){
					el = $(el);
					var options = el.data("options");
					var name = el.data("name");
					el.addClass("vetology_widget_loaded");
					el.on("change", function(){
						var toggler = $(".data_toggler.toggler_" + el.data("toggler"));
						var els = el.val();
						var elseF = [];
						$.each(els, function(u,l){
							elseF.push('' + l);
						});
						var els2 = toggler.find(".toggler_block");
						$.each(els2, function(i, e2){
							const e = $(this);
							var id = '' + e.data("id");
							if($.inArray(id, elseF) === -1){
								e.remove();
							}
						});
						$.each(elseF, function(i, val){
							var el2 = $('.toggler_block[data-id="' + val + '"]');
							if(el2.length === 0){
								var html = '<div data-id="' + val + '" class="toggler_block">';
								html += el.find('option[value="' + val + '"]').text() + '<select class="select2 select2n vetology_widget_loaded form-control" multiple="multiple" name="' + name + '_' + val + '[]">';
								$.each(options, function(t,f){
									html += '<option value="' + t + '">' + f + '</option>';
								});
								html += '</select>';
								html += '<br><br></div>';
								toggler.append(html);								
							}
						});
						$(".select2n").select2();
					});
				});
				o._doPopTitle();
				$('.fileSizeNonReadable').each(function(i, e){
					e = $(e);
					var size = parseInt(e.html(), 10);
					e.html(o.humanFileSize(size, false));
				});
                $('.pop_content').popover();
            },
			/*
			 * Vetology.Vetology._loadWidgets
			 *
			 * @description	Initializes the widgets
			 *
			 * @return NULL
			 *
			 */
			humanFileSize: function(bytes, si) {
				var thresh = si ? 1000 : 1024;
				if(Math.abs(bytes) < thresh) {
					return bytes + ' B';
				}
				var units = si ? ['KiB','MiB','GiB','TiB','PiB','EiB','ZiB','YiB'] : ['kB','MB','GB','TB','PB','EB','ZB','YB'];
				var u = -1;
				do {
					bytes /= thresh;
					++u;
				} while(Math.abs(bytes) >= thresh && u < units.length - 1);
				return bytes.toFixed(1)+' '+units[u];
			},
			/*
			 * vetology.platform._showConfirmDialog
			 *
			 * @description	This method shows a confirmation dialog message, if confirmed then a callback function is called.
			 *
			 * @param String 	title		The title for the dialog
			 * @param String 	message		The content of the dialog
			 * @param Function 	callback	The callback function upon success
			 *
			 * @return NULL
			 *
			 */
			_shred: function(el){
				var wrap = el.closest('.removeItemWrap');
				wrap.animate(
					{
						opacity : 0
					},
					1500,
					'easeInOutBounce',
					function(){
						wrap.remove()
					}
				);
			},
			_updateStatus: function(el) {
				var $el = $(el);
				var text = $el.text().trim();
				var updateCase = $el.data('update');
				var $caseCard;
				if (updateCase) {
					$caseCard = $(updateCase);
				} else {
					$caseCard = $el.closest('.box-case');
				}
				var $statusLabel = $('.case_canvas .case-submit-status', $caseCard);

				if (text == 'Store' || text == 'Store only') {
					$statusLabel.text('Stored');
					$statusLabel.removeClass('label-danger');
					$statusLabel.addClass('label-info');
				} else if (text == 'Submit for review') {
					$statusLabel.text('Pending Review');
					$statusLabel.removeClass('label-danger');
					$statusLabel.addClass('label-warning');
					// remove submit tile button
					var $submitTile = $('.isSubmitButton', $caseCard);
					$submitTile.remove();
				} else if (text == 'Delete') {
					let $caseCard = $el.closest("div[data-case]");
					var caseID = $caseCard.data('case');
					$caseCard.addClass('caseDeleted');
					let $caseCanvas = $(".case_canvas", $caseCard);
					$caseCanvas.append($("<a data-case='" + caseID + "' href='#' class='vetology_pd caseRestore'>Restore <span class='vetology-rotate-ccw'></span></a>"));
				}
			},
			/*
			 * vetology.platform._showConfirmDialog
			 *
			 * @description	This method shows a confirmation dialog message, if confirmed then a callback function is called.
			 *
			 * @param String 	title		The title for the dialog
			 * @param String 	message		The content of the dialog
			 * @param Function 	callback	The callback function upon success
			 *
			 * @return NULL
			 *
			 */
			_shredTR: function(el){
				el.closest('tr').remove();
			},
			/*
			 * vetology.platform._showConfirmDialog
			 *
			 * @description	This method shows a confirmation dialog message, if confirmed then a callback function is called.
			 *
			 * @param String 	title		The title for the dialog
			 * @param String 	message		The content of the dialog
			 * @param Function 	callback	The callback function upon success
			 *
			 * @return NULL
			 *
			 */
			_shredRow: function(el){
				this._removeOCR(el);
			},
			/*
			 * Vetology.Vetology._loadWidgets
			 *
			 * @description	Initializes the widgets
			 *
			 * @return NULL
			 *
			 */
			_loadWidgets: function(){
				var o = this;
				var widgets = $("body").attr("class").split(" ");
				$.each(widgets, function(i, widget){
					widget = widget.trim();
					if (widget.indexOf("Vetology_") !== -1) {
						o.loadWidgetsLoadWidget(widget);
					}
				});
			},
			"loadWidgetsLoadWidget": function (widget) {
				const o = this;
				widget = widget.replace('Vetology_', '');
				if (widget.indexOf('class_') === 0) {
					const className = widget.replace('class_', '');
					if (o.options.dev) {
						console.info("Loading class: Vetology." + className);
					}
					const customEvent = new CustomEvent('vetology-load-page-event', {
						detail: {
							className: className
						}
					});
					document.dispatchEvent(customEvent);
				} else {
					o.loadWidgetsLoadStandardWidget(widget);
				}
			},

			loadWidgetsLoadStandardWidget: function (widget) {
				const o = this;
				if (typeof o.options.load_widgets[widget] !== "undefined" && typeof $("body")[widget] !== "undefined" && o.options.load_widgets[widget].init) {
					var params = o.options.load_widgets[widget];
					var selector = (typeof params.triggerOn != "undefined" ? params.triggerOn : "body");
					if (o.options.dev) {
						console.info("Loading widget: Vetology." + widget + ' on selector(s) ' + selector);
					}
					if (typeof jQuery.Vetology[widget] === "function") {
						$(selector)[widget](params.options);
						if (typeof o.options.load_widgets[widget].onInit == "function") {
							o.options.load_widgets[widget].onInit();
						}
					} else {
						console.error("The widget Vetology." + widget + " has been attempted to be loaded but it was not included in the script assets");
					}
				} else {
					if (typeof o.options.load_widgets[widget] != "undefined" && o.options.load_widgets[widget].init) {
						if (typeof $("body")[widget] !== "undefined" && !$("body").hasClass("Vetology_" + widget)) {
							console.warn("Vetology." + widget + " widget enabled but no active elements to use it on on the page.");
						} else {
							console.error("Attempt to load Vetology." + widget + " but widget is not included in page.");
						}
					}
				}
			},

			/*
			 * Vetology.Vetology._loadVendorWidgets
			 *
			 * @description	Initializes the vendor widgets
			 *
			 * @return NULL
			 *
			 */
			"_loadVendorWidgets": function () {
				$(".custom_scrollbar").addClass("scrollbar-chrome").mCustomScrollbar();
				$(".select2").select2();
			},
			/*
			 * Vetology.Vetology._loadTriggers
			 *
			 * @description	Initializes the triggers on the DOM
			 *
			 * @return NULL
			 *
			 */
			"_loadTriggers": function(){
				var o = this;
				o.options.modal = $(".vetology_messages");
				o.options.modal.modal({"show": false});
				$("body").on("click", ".vetology_pd", function(e){
					e.preventDefault();
					var el = $(this);
					el.closest(".radio_image").find("a").removeClass("radio_selected");
					el.addClass("radio_selected");
					if(typeof el.data("click") != "undefined"){
						$(el.data("click")).click();
					}
				});
				$("body").on("click", ".send_email_to_owner", function(e){
					e.preventDefault();
					var url = location.href + '&submit=true&email=' + $('[name="owner_email"]').val();
					var message = "Please wait while I send your email to " + $('[name="owner_email"]').val();
					o.doRequest("GET", {}, url, function(data){
						if(data.error){
							o.vetologyShowDialog('Error: ' + data.message, "error");
						} else {
							o.vetologyShowDialog('Success: ' + data.message, "success");
						}
					}, "JSON", true, message, message);
				});
				$("body").on("keyup", ".loginForm input", function(e){
                    var key=event.which || event.keyCode;
					if(key===13){
                        $(".login_action").click();
					}
				});
                $('body').on('click', '.closeLion', function(e){
                    e.preventDefault();
                    var el = $(this);
                    el.addClass('disabled').attr('disabled', 'disabled');
                    var close_lion = confirm('Are you sure?\nThis will stop all lione functionality.');
                    if(close_lion){
                        $.ajax(
                            {
                                url		: '/exitLion',
                                method	: 'get',
                                data	: {id:el.data('id')}
                            }
                        );
                    }
                });
                $("body").on("click", ".radio_image_selector", function(){
					var el = $(this);
					var target = $(el.data("target"));
					var value = el.data("value");
					console.log(target, value);
					target.val(value);
				});
				$("body").on("click", ".html_alert", function(e){
					e.preventDefault();
					var el = $(this);
					if(!el.hasClass("modalActive")){
						el.addClass("modalActive");
					}
					$("#" + el.data("ref")).modal({show:true});
				})
				$('body').on('click', '.cancelShare', function(e){
					e.preventDefault();
					var el = $(this);
					$.ajax(
						{
							url		: '/worklist/clinic/case/share/cancel',
							method	: 'get',
							data	: {
								id		: el.data('id')
							},
							success	: function(j){
								if(j.canceled == 1){
									$('.shareExpiry[data-id="' + el.data('id') + '"]').html('<span class="label label-danger">' + j.date + '</span>');
									el.remove();
                                    $("body").Vetology("vetologyShowDialog", "Success:", "Share successfully canceled", "success");
								} else {
                                    $("body").Vetology("vetologyShowDialog", "Success:", j.message, "success");
								}
							},
							dataType: 'JSON'
						}
					);
				});
				$("body").on("click", ".close_loading_shade", function(e){
					o.vetologyLoadEnd();
				});
				$("body").on("click", ".forgotFormToggler", function(e){
					e.preventDefault();
					var el = $(this);
					$(".formBlock").addClass("hide");
					$(el.data("form")).removeClass("hide");
					$(".loginlog").html("");
				});
				$("body").on("click", ".login_recover", function(e){
                    const emailInput = document.body.querySelector('input[name="email-on-file"]');
                    const email = emailInput.value;
                    if (!emailInput || !emailInput.validity.valid || emailInput.value.length === 0 || null === email.match(/^[_a-z0-9-]+(\.[_a-z0-9-]+)*@[a-z0-9-]+(\.[a-z0-9-]+)*(\.[a-z]{2,})$/i)) {
                        $('body').Vetology("vetologyShowDialog", "Error:", "Please provide a valid email address.", "error");
                        return;
                    }

					$.when(o.passwordSendResetAttempt()).then(
						function(data){
							$("body").Vetology("vetologyShowDialog", "Success:", "If you have an account in our system, an email will be sent to your specified email address.", "success");
						}
					);
				});
				$('.migrateForm').on('submit', function(e){
					e.preventDefault();
					o._attemptMigration();
				});
				$("body").on("click", ".login_reset", function(e){
					$.when(o.passwordResetAttempt()).then(
						function(data){
							if(data.valid){
								$("body").Vetology("vetologyShowDialog", "Success:", "Password has been reset you may now login.", "success");
							} else {
								var e = "<ul>";
								$.each(data.reason, function(i,r){
									e += '<li><span class="label label-warning">' + r + '</span></li>';
								});
								e += "<ul>";
								$("body").Vetology("vetologyShowDialog", "Error:", e, "error");
							}	
						}
					);
				});

				o.loadTriggersFinish();
			},
			"loadTriggersFinish": function () {
				const o = this;
				$("body").on("click", ".login_action", function (e) {
					var el = $(this);
					var i = 0;
					while (i < 5) {
						i++;
						el = el.parent();
						if (el.find('[name="user_name"]').length > 0) {
							break;
						}
					}
					var user = el.find('[name="user_name"]').val();
					var password = el.find('[name="password"]').val();
					$.when(o.loginAttempt(user, password)).then(
						function (data) {
							if (data.valid) {
								o.vetologyLoadStart("Credentials valid:<br>Please wait while I load your configuration", "Credentials valid:<br>Please wait while I load your configuration");
								if ($("._redirectTo").length > 0 && data.redirectTo) {
									return location.replace(data.redirectTo);
								}
								location.reload();
							} else if (data.isMigration) {
								$("body").Vetology("vetologyShowDialog", "Attention:", "The given account needs to be migrated before it can be used in the new Vetology Platform.<br>Please complete the following form to complete the migration.", "info");
								$('.migrateForm').find('[name="old_password"]').val(data.password);
								$('.migrateForm').find('[name="uname"]').val(data.name);
								$('.loginData').addClass('hide');
								$('.migrationForm').removeClass('hide');
							} else {
								var message = (typeof data.message != 'undefined' ? data.message : "The provided credentials are not valid.<br>Please verify them and try again.");
								$("body").Vetology("vetologyShowDialog", "Error:", message, "error");
							}
						}
					);
				});
				$("body").on("showCalendar.daterangepicker", '.dateRanger', function (e) {
					var el = $(this);
				});
				$('body').on('click', '.dateRanger', function (e) {
					var el = $(this);
					if (el.hasClass('dateRangeEnabled')) {
						return;
					}
					el.addClass('dateRangeEnabled');
					var settings = {
						ranges: {
							'Today': [moment(), moment()],
							'Yesterday': [moment().subtract(1, 'days'), moment().subtract(1, 'days')],
							'Last 7 Days': [moment().subtract(6, 'days'), moment()],
							'Last 30 Days': [moment().subtract(29, 'days'), moment()],
							'Last 60 Days': [moment().subtract(60, 'days'), moment()],
							'All time': [moment().subtract(29, 'years'), moment().add(30, 'days')]
						},
						"showDropdowns": true,
						startDate: moment().subtract(60, 'days'),
						endDate: moment()
					};
					if (typeof el.data("maxdate") !== "undefined") {
						settings.maxDate = moment(el.data("maxdate"), "MM/DD/YYYY");
					}
					if (typeof el.data("mindate") !== "undefined") {
						settings.minDate = moment(el.data("mindate"), "MM/DD/YYYY");
					}
					console.log(settings);
					el.daterangepicker(
						settings,
						function (start, end, label) {
							el.find('input').val(start.format('YYYY-MM-DD') + '::' + end.format('YYYY-MM-DD'));
							$(".isFilter").trigger("change");
							el.find('span').html('<i class="vetology-calendar"></i>&nbsp;' + label);
						}
					).click();
				});
				$("body").on("change", ".form-group textarea", function (e) {
					o._updateErrorField($(this));
				});
				$("body").on("change", ".form-group select", function (e) {
					o._updateErrorField($(this));
				});
				$("body").on("change", ".form-group input", function (e) {
					o._updateErrorField($(this));
				});
				$("body").on("click", ".vetology_resize", function () {
					$(window).resize();
				});
				$("body").on("click", "#download-subscription-csv", function () {
					const headerRow = document.querySelector('table[summary] thead tr');
					const inputs = headerRow.querySelectorAll('.isFilter');
					const formData = new FormData();
					for (const input of inputs) {
						formData.append(input.dataset.filter, input.value);
					}
					const queryStringObj = new URLSearchParams(formData);

					var win = window.open('/admin/subscription/download-csv?perpage=all&' + queryStringObj.toString(), '_blank');
					win.focus();
				});
				$("body").on("change", ".update_my_profile", function () {
					var theme = $(".page_theme").val();
					$("body").removeClass('theme_default theme_dark');
					$("body").addClass(theme);
					$.ajax(
						{
							type: 'POST',
							url: '/user/account',
							data: {
								"theme": theme,
								"selected": true
							},
							dataType: 'JSON',
							success: function (data) {
							}
						}
					);
				});
				$('body').on('click', '.trigger_reply', function (e) {
					e.preventDefault();
					var el = $(this).closest('.direct-chat-msg');
					$('.reply_box').removeClass('hide');
					$('.refnotes').attr('placeholder', 'Enter a note for ' + el.data('shname'));
					$('#ocrId').val(el.data('reply'));
					$('#ocrcId').val(el.data('sh_case'));
				});

				$(window).resize();
			},

			/*
			 * Vetology.Vetology._attemptMigration
			 *
			 * @description	REmoves the error highlightiung form the form block 
			 *
			 * @return NULL
			 *
			 */
			"_attemptMigration": function(el){
				$.ajax(
					{
						url		: "/migrate",
						method	: "POST",
						data	: $('.migrateForm').serialize(),
						dataType: "JSON",
						statusCode: window.serverErrors,
						error		: function(a, b, c){
							$("body").Vetology("vetologyShowDialog", 'There was an unknown error, please check the log.', 'There was an unknown error, please check the log.', "error");
						},
						success		: function(data){
							if(data.errors.length != 0){
								var message = '<p>Please correct the errors:</p><ul>';
								$.each(data.errors, function(i,error){
									$('[name="' + i + '"]').closest('.form-group').addClass('has-error');
									message += '<li>' + error + '</li>';
								});
								message += '</ul>';
								$("body").Vetology("vetologyShowDialog", message, message, "error");
							} else {
								$("body").Vetology("vetologyShowDialog", message, '<p>Your account has been migrated, please use your new user name and password the next time you log in.</p>You will be redirected in a moment', "success");
								setTimeout(
									function(){
										location.replace(data.route);
									}, 10000
								);
							}
						}
					}
				);
			},
			/*
			 * Vetology.Vetology._updateErrorField
			 *
			 * @description	REmoves the error highlightiung form the form block 
			 *
			 * @return NULL
			 *
			 */
			"_updateErrorField": function(el){
				el.closest(".form-group").removeClass("has-error").find(".help-block").html("");
			},
			/*
			 * Vetology.Vetology.preflight
			 *
			 * @description	Starts loading actions on page 
			 *
			 * @return NULL
			 *
			 */
			"preflight": function(callback){
                const data = {
                    cors: true
                };
                if ('case_id' in document.body.dataset) {
                    data.case_id = document.body.dataset.case_id
                }
				$.ajax({
					url: '/preflight',
					data: data,
					success: function(preflight){
						if(typeof callback == "function"){
							callback(preflight);
						}
					}
				});
			},
			/*
			 * Vetology.Vetology.getCharts
			 *
			 * @description	adds the google charts script
			 *
			 * @return NULL
			 *
			 */
			"getCharts": function(callback){
				var o = this;
				if(typeof window.vetology_gcharts == "undefined"){
					window.vetology_gcharts = false;
					$.getScript("https://www.gstatic.com/charts/loader.js")
						.done(function(script, textStatus) {
							window.vetology_gcharts = true;
							callback();
						})
						.fail(function(jqxhr, settings, exception){
							/*do something here*/
						});
				} else if(window.vetology_gcharts === true){
					callback();
				} else {
					setTimeout(
						function(){
							o.getCharts(callback);
						}, 300
					);
				}
			},
			/*
			 * Vetology.Vetology.doRequest
			 *
			 * @description	Makes an ajax request with the given parameters
			 *
			 * @return NULL
			 *
			 */
			"doRequest": function(method, data, url, done, type, notAfterAjax, message, tired_of_wating){
				var o = this;
				o.vetologyLoadStart(message, tired_of_wating);
				if(o.options.doingAjax){
					console.warn('An ajax call is running at this time, please wait.');
					var arI = setInterval(
						function(){
							if(!o.options.doingAjax){
								clearInterval(arI);
								o.doRequest(method, data, url, done, type, notAfterAjax, message, tired_of_wating);
							}
						}, 10
					);
					return;
				}
				o.options.doingAjax = true;
				$.each($(".select2"), function(i,sel){
					const s = $(this);
					if(typeof s.data("select2") != "undefined"){
						s.select2('destroy');
					}
				});
				$(".select2.select2-container").remove();
				if($('.reportSection table').length > 0){
					$('.reportSection table').DataTable({"bDestroy" : true});
				}
				$.ajax(
					{
						url		: url,
						method	: method,
						data	: data,
						dataType: type,
						statusCode: window.serverErrors,
						error : function(a){
							console.log(a);
							o.vetologyLoadEnd();
							if(a.status !== 200){
								if (typeof a.status != 'undefined' && a.status == 422 && typeof a.responseJSON == 'object' && typeof a.responseJSON.errors != 'undefined') {
									o.processFormValidationErrors(a.responseJSON);
								} else {
									o.vetologyShowDialog('Error: ' + a.status, a.statusText + '<br>' + a.responseText, "error");
								}
							} else {
								o.vetologyShowDialog('Error: ', 'The server responded with something unexpected.', "error");
							}
							o.options.doingAjax = false;
						},
						success		: function(response){
							$.when(done(response)).then(function () {
                                o._initDOMElements();
                                o.vetologyLoadEnd();
                                o.options.doingAjax = false;
                                if (typeof notAfterAjax !== "undefined" && notAfterAjax !== false) {
                                    o.setTableExporter();
                                    //processAfterAjax();
                                }
                                $(".select2").select2();
                            });
						}
					}
				);
			},
			_showDialog: function(title, message, callback){
				this.vetologyShowDialog(title, message, "info", callback);
			},
			/*
			 * Vetology.Vetology.vetologyLoadStart
			 *
			 * @description	Starts loading actions on page 
			 *
			 * @return NULL
			 *
			 */
			"processFormValidationErrors": function(json) {
				const o = this;
				let errorList = "";
				$.each(json.errors, function(elemName, errorMsgs) {
					const $elem = $("[name='" + elemName + "']");
					if ($elem.length) {
						$elem.closest('.form-group').addClass('has-error');
					}
					$.each(errorMsgs, function(idx, msg) {
						errorList += msg + "<br/>";
					});
				});
				o.vetologyShowDialog('Error: ', errorList, "error");

			},

			"vetologyShowDialog": function(title, message, level, callback, button_close_text, button_ok_text){
				var o = this;
				button_ok_text = typeof button_ok_text === "undefined" ? "OK" : button_ok_text;
				button_close_text = typeof button_close_text === "undefined" ? "Close" : button_close_text;
				var button = typeof callback == "function" ? $("<button class='pull-right callback_triggered callback_triggered btn btn-sm btn-primary'>" + button_ok_text + "</button><div style=\"clear:both\"></div>") : "";
				o.options.modal.find(".modal-footer [data-dismiss]").html(button_close_text);
				o.options.modal.find(".modal-title").html(title);
				o.options.modal.find(".modal-body").html("<form class='form_builder form-horizontal'>" + message + "</form>");
				o.options.modal.find(".modal-dialog").attr("class", "modal-dialog modal-lg");
				o.options.modal.removeClass("modal-danger modal-success modal-warning modal-info alert-danger alert-success alert-warning alert-info");
				switch(level){
					case "error":
						o.options.modal.addClass((typeof o.options.modal.data("base") != "undefined" ? o.options.modal.data("base") : "alert") + "-danger");
						break;
					case "success":
						o.options.modal.addClass((typeof o.options.modal.data("base") != "undefined" ? o.options.modal.data("base") : "alert") + "-success");
						break;
					case "warning":
						o.options.modal.addClass((typeof o.options.modal.data("base") != "undefined" ? o.options.modal.data("base") : "alert") + "-warning");
						break;
					case "info":
						o.options.modal.addClass((typeof o.options.modal.data("base") != "undefined" ? o.options.modal.data("base") : "alert") + "-info");
						break;
					default:
						break;
				}
				o.options.modal.modal("show");
				o.options.modal.on('hidden.bs.modal', function () {
					o.options.modal.find(".modal-body").html("");
				});
				if(typeof callback == "function"){
					o.options.modal.find(".modal-body").append('<br>').append(button);
					button.on("click", function(){
						var fields = $(".form_builder").serialize();
						callback(fields, o.options.modal);
					});
				}
			},
			/*
			 * Vetology.Vetology.passwordResetAttempt
			 *
			 * @description	Attempt to log in a user
			 *
			 * @return NULL
			 *
			 */
			"passwordResetAttempt": function(email){
				var o = this;
				var deferred = new $.Deferred();
				o.vetologyLoadStart("Please wait:<br>Validating your credentials...", "Please wait:<br>Validating your credentials...");
				var data = {
					email			: $('.remail').val(),
					token			: $('.rtoken').val(),
					password		: $('.rpassword').val(),
					passwordc		: $('.rpasswordc').val(),
					recoverAttempt	: true,
				};
				$.ajax(
					{
						type: 'POST', 
						url: '/password-recovery', 
						data: data, 
						dataType: 'JSON',
						success: function(data){
							o.vetologyLoadEnd();
							deferred.resolve(data);
						}
					}
				);
				return deferred.promise();
			},
			/*
			 * Vetology.Vetology.passwordSendResetAttempt
			 *
			 * @description	Attempt to log in a user
			 *
			 * @return NULL
			 *
			 */
			"passwordSendResetAttempt": function(email){
				var o = this;
				var deferred = new $.Deferred();
				o.vetologyLoadStart("Please wait:<br>Validating your email...", "Please wait:<br>Validating your email...");
				var data = {
					email : $('[name="email-on-file"]').val(),
					recover: true,
				};
				$.ajax(
					{
						type: 'POST', 
						url: '/', 
						data: data, 
						dataType: 'JSON',
						success: function(data){
							o.vetologyLoadEnd();
							deferred.resolve(data);
						}
					}
				);
				return deferred.promise();
			},
			/*
			 * Vetology.Vetology.loginAttempt
			 *
			 * @description	Attempt to log in a user
			 *
			 * @return NULL
			 *
			 */
			"loginAttempt": function(user, password){
				var o = this;
				var deferred = new $.Deferred();
				o.vetologyLoadStart("Please wait:<br>Validating your credentials...", "Please wait:<br>Validating your credentials...");
				var data = {
					username: user,
					password: password,
				};
				if($("._redirectTo").length > 0){
					data._redirectTo = $("._redirectTo").val();
				}
				$.ajax(
					{
						type: 'POST', 
						url: '/', 
						data: data, 
						dataType: 'JSON',
						success: function(data){
							o.vetologyLoadEnd();
							deferred.resolve(data);
						}
					}
				);
				return deferred.promise();
			},
			/*
			 * Vetology.Vetology.vetologyLoadStart
			 *
			 * @description	Starts loading actions on page 
			 *
			 * @return NULL
			 *
			 */
			"vetologyLoadStart": function(message, tired_of_wating, icon){
				var o = this;
				if(typeof icon === "undefined"){
					$(".vetology_loader").find(".spin").removeClass("hide");
				} else {
					$(".vetology_loader").find(".spin").addClass("hide");
				}
				message = typeof message != "undefined" && message != "" ? message : "Please wait while the request completes";
				tired_of_wating = typeof tired_of_wating == "undefined" ? message + '<br><a href="#" class="vetology_pd close_loading_shade"><small>Tired of waiting?, click here to close this and continue working</small></a>' : tired_of_wating;
				if(o.options.pageTitle.interval != null){
					return;
				}
				$(".load_pending_text").html(message);
				clearTimeout(o.options.loadTO);
				o.options.loadTO = setTimeout(
					function(){
						$(".load_pending_text").html(tired_of_wating);
					},
					5000
				);
				$("body").addClass("load_pending");
				o.options.pageTitle.interval = setInterval(function(){
					o.options.pageTitle.index++;
					if(o.options.pageTitle.index==o.options.pageTitle.sequence.length){
						o.options.pageTitle.index = 0;
					}
					window.document.title = o.options.pageTitle.sequence[o.options.pageTitle.index] + " " + o.options.pageTitle.title;
				},100);
			},
			/*
			 * Vetology.Vetology.vetologyLoadEnd
			 *
			 * @description	Stops loading actions on page and triggers on load end actions
			 *
			 * @return NULL
			 *
			 */
			"vetologyLoadEnd": function(force){
				var o = this;
				$("body").removeClass("load_pending");
				clearInterval(o.options.pageTitle.interval);
				o.options.pageTitle.interval = null;
				window.document.title = o.options.pageTitle.title;
				o._setDoubleScroll();
				o._setTimers();
				$(window).resize();
			},
			/*
			 * vetology.platform._setTimers
			 *
			 * @description	This method allows to get GET parameter values from the URL.
			 *
			 * @param String name	The parameter name that is being searched for
			 *
			 * @return String|Boolean	The value of the parameter if exists false otherwise
			 *
			 */
			"_setTimers": function(){
				var timers = $('.update_timer:not(.timer_set)');
				$.each(timers, function(i, tmr){
					const t = $(this);
					t.uniqueId();
					var id = t.attr("id");
					var ti = setInterval(
						function(){
							if($("#" + id).length === 0){
								clearInterval(ti);
							}
							var seconds = parseInt(t.data("seconds"));
							var minutes = parseInt(t.data("minutes"));
							var hours = parseInt(t.data("hours"));
							if(seconds === 59){
								seconds = 0;
								minutes ++;
							}
							seconds ++;
							if(minutes === 59){
								minutes = 0;
								hours ++;
							}
							seconds = ("0" + seconds).slice(-2);
							minutes = ("0" + minutes).slice(-2);
							hours = ("0" + hours).slice(-2);
							t.data("seconds", seconds);
							t.data("minutes", minutes);
							t.data("hours", hours);
							t.html(hours + ":" + minutes + ":" + seconds);
						}, 1000
					);
				});
			},
			/*
			 * vetology.platform._setDoubleScroll
			 *
			 * @description	This method allows to get GET parameter values from the URL.
			 *
			 * @param String name	The parameter name that is being searched for
			 *
			 * @return String|Boolean	The value of the parameter if exists false otherwise
			 *
			 */
			"_setDoubleScroll": function() {
				var o = this;
				$(window).scroll(function(){
					clearTimeout(o.options.scrollEnd);
					o.options.scrollEnd = setTimeout(
						function(){
							if($('.scrollbar_top').length==0){
								return;
							}
							o._setDoubleScrollPossition();
						},
						300
					);
				});
				if($('.scrollbar_top').length==0){
					return;
				}
				o._setDoubleScrollPossition();
			},
			/*
			 * vetology.platform._setDoubleScrollPossition
			 *
			 * @description	This method allows to get GET parameter values from the URL.
			 *
			 * @param String name	The parameter name that is being searched for
			 *
			 * @return String|Boolean	The value of the parameter if exists false otherwise
			 *
			 */
			"_setDoubleScrollPossition": function() {
				var scrollParent = $('.mainContainer');
				var table = scrollParent.find('table');
				var scrollbar_top = $('.scrollbar_top').css({width: scrollParent.width() + 'px'});
				var scrollbar_bottom = scrollParent.find('.scrollbar_bottom');
				if(table.width() > scrollParent.width()){
					scrollbar_top.removeClass('hide').find('.scroller_handle').width(table.width());
					scrollbar_top.scroll(function(){
						scrollParent.scrollLeft(scrollbar_top.scrollLeft());
					});
					scrollParent.scroll(function(){
						scrollbar_top.scrollLeft(scrollParent.scrollLeft());
					});
				} else {
					scrollbar_top.addClass('hide');
				}
				scrollbar_top.toggleClass('sticky', $(window).scrollTop() + 50 > scrollParent.offset().top);
			},
			/*
			 * vetology.platform.getUniqueIdentifier
			 *
			 * @description	This method allows to get GET parameter values from the URL.
			 *
			 * @param String name	The parameter name that is being searched for
			 *
			 * @return String|Boolean	The value of the parameter if exists false otherwise
			 *
			 */
			"getUniqueIdentifier": function() {
				function s4() {
					return Math.floor((1 + Math.random()) * 0x10000).toString(16).substring(1);
				}
				return s4() + s4() + '-' + s4() + '-' + s4() + '-' + s4() + '-' + s4() + s4() + s4();
			},
			/*
			 * vetology.Vetology._getParam
			 *
			 * @description	This method allows to get GET parameter values from the URL.
			 *
			 * @param String name	The parameter name that is being searched for
			 *
			 * @return String|Boolean	The value of the parameter if exists false otherwise
			 *
			 */
			_getUrlParam: function(name) {
				name = name.replace(/[\[]/, "\\[").replace(/[\]]/, "\\]");
				var regex = new RegExp("[\\?&]" + name + "=([^&#]*)"),
				results = regex.exec(location.search);
				var value = results === null ? false : decodeURIComponent(results[1].replace(/\+/g, " "));
				return value;
			},
			/*
			 * vetology.Vetology._log
			 *
			 * @description	Logs a message to the browser's console, if and only if vetology.platform.options.debug variable is true.
			 *
			 * @param String|Object	The message or variable to log
			 * @param String		The type of log (log, warn, error)
			 *
			 * @return NULL
			 */
			_log: function(message, type) {
				if(this.options.debug || type == 'info'){
					if(typeof message == 'undefined'){
						throw new Error('The vetology.platform._log method expects parameter 1 to be string, null given');
					} else {
						type = typeof type != 'undefined' ? type : 'log';
						switch(true){
							case typeof message == 'string':
								console[type](message);
							break;
							case typeof message == 'object':
								if(message.constructor.name == '' && typeof message.widgetFullName != 'undefined'){
									var keys = Object.keys(message);
									console.info(message.widgetFullName + '(' + keys.length + ') {');
									console[type](message);
									console.info('}');
								} else {
									if(message.constructor.name == 'Array'){
										console.info('array(' + message.length + ') {');
										console[type](message);
										console.info('}');
									} else if(message.constructor.name == 'Object') {
										var keys = Object.keys(message);
										console.info('object(stdClass) (' + keys.length + ') {');
										console[type](message);
										console.info('}');
									} else {
										console.info('Unknown object {');
										console[type](message);
										console.info('}');
									}
								}
							break;
							case typeof message == 'number':
								console[type]('Number value: ' + message);
							break;
							default:
								console[type](message);
							break;
						}
					}
				}
			},
			/*
			 * vetology.platform._setMap
			 *
			 * @description	Gets a vetology.gmap with a Google Maps instance to interact with it.
			 *
			 * @param vetology.gmap map	The vetology.gmap object
			 *
			 * @return NULL
			 *
			 */
			_setMap	: function(map){
				this.options.map = map;
			},
			/*
			 * vetology.platform.setTableExporter
			 *
			 * @description	Gets a vetology.gmap with a Google Maps instance to interact with it.
			 *
			 * @param vetology.gmap map	The vetology.gmap object
			 *
			 * @return NULL
			 *
			 */
			setTableExporter	: function(){
				$.each($('.reportSection table'), function(i, t){
					t = $(t);
					var name = t.closest(".box").find(".box-title").html();
					var buttons = t.DataTable({buttons: [
						{
							extend: 'colvis',
							filename: name,
							text: '<span title="View/Hide Columns" class="buttonInfo vetology-hide"></span>/<span class="vetology-view"></span>'
						},
						{
							extend: 'print',
							filename: name,
							text: '<span title="Print" class="buttonInfo vetology-fax"></span>'
						},
						{
							extend: 'excel',
							sheetName: name,
							createEmptyCells: true,
							filename: name,
							title : name,
							text: '<span title="Export as Excel xlsx (Visible rows)" class="buttonInfo vetology-document-file-xlsx"></span>',
							exportOptions : {
								modifier : {
									order : 'current',
									page : 'current',
									search : 'applied'
								}
							}
						},
						{
							extend: 'excel',
							sheetName: name,
							createEmptyCells: true,
							filename: name,
							title : name,
							text: '<span title="Export as Excel xlsx (All rows)" class="buttonInfo vetology-document-file-xlsx"></span>',
							exportOptions : {
								modifier : {
									order : 'current',
									page : 'all',
									search : 'none'
								}
							}
						},
						{
							extend: 'csv',
							sheetName: name,
							createEmptyCells: true,
							filename: name,
							title : name,
							text: '<span title="Export as comma separated values (Visible rows)" class="buttonInfo vetology-document-file-xls"></span>',
							exportOptions : {
								modifier : {
									order : 'current',
									page : 'current',
									search : 'applied'
								}
							}
						},
						{
							extend: 'csv',
							sheetName: name,
							createEmptyCells: true,
							filename: name,
							title : name,
							text: '<span title="Export as comma separated values (All rows)" class="buttonInfo vetology-document-file-xls"></span>',
							exportOptions : {
								modifier : {
									order : 'current',
									page : 'all',
									search : 'none'
								}
							}
						},
						{
							extend: 'pdf',
							sheetName: name,
							createEmptyCells: true,
							filename: name,
							title : name,
							text: '<span title="Export as PDF (Visible rows)" class="buttonInfo vetology-document-file-pdf"></span>',
							exportOptions : {
								modifier : {
									order : 'current',
									page : 'current',
									search : 'applied'
								}
							}
						},
						{
							extend: 'pdf',
							sheetName: name,
							createEmptyCells: true,
							filename: name,
							title : name,
							text: '<span title="Export as PDF (All rows)" class="buttonInfo vetology-document-file-pdf"></span>',
							exportOptions : {
								modifier : {
									order : 'current',
									page : 'all',
									search : 'none'
								}
							}
						},
						{
							extend: 'copy',
							sheetName: name,
							createEmptyCells: true,
							filename: name,
                            title: name,
                            text: '<span title="Copy to clipboard" class="buttonInfo vetology-pages"></span>'
                        }
                        ]
                    }).buttons().container();
                    t.closest(".box").find(".box-tools").append(buttons);
                });
                $.each($(".buttonInfo"), function (i, b) {
                    b = $(b);
                    b.closest("button").attr("title", b.attr("title"));
                });
            },
            /*
             * vetology.platform._renderNote
             *
             * @description	This method shows a confirmation dialog message, if confirmed then a callback function is called.
             *
             * @param String 	title		The title for the dialog
             * @param String 	message		The content of the dialog
             * @param Function 	callback	The callback function upon success
             *
             * @return NULL
             *
             */
            _renderNote: function () {
                var messageClone = $('.messageTemplate').clone();
                messageClone.removeClass('hide').removeClass('messageTemplate');
                messageClone.find('.direct-chat-text').html($('.refnotes').val());
                var currentDate = new Date();
                var monthNames = ["Jan", "Feb", "Mar", "Apr", "May", "Jun",
                    "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"
                ];
                var ampm = currentDate.getHours() >= 12 ? 'pm' : 'am';
                messageClone.find('.direct-chat-timestamp').html(
                    currentDate.getDate()
                    + ' '
                    + monthNames[currentDate.getMonth()]
                    + ' '
                    + currentDate.getHours()
                    + ':'
                    + currentDate.getMinutes()
                    + ' '
                    + ampm
                );
                $('.direct-chat-messages').append(messageClone);
                $('.refnotes').val('');
            },
            /*
            * Vetology.Vetology.updateDoctor
            *
             */
            _updateDoctor: function (el) {
                // update id with new id
                $('input[name=sid]').val(el.json.id);
                var $btns = $('button[data-url*="/doctors"]');
                $btns.attr('data-url', "/doctors?a=2&spid=" + el.json.id);
                $btns.data('url', "/doctors?a=2&spid=" + el.json.id);
            },

			_updateDeleteCategoryAttempt: function($el) {
            	const  $table = $el.closest('tr.row-actions').closest('table');
            	$el.closest('tr.row-actions').prev('tr').remove();
            	$el.closest('tr.row-actions').remove();

			},

			_checkNonconformance: function() {
				var o = this;
            	$.ajax({
		            url: '/user/check-nonconformance-level',
		            method: 'get',
		            dataType: 'json'
	            }).done(function(data, textStatus, jqXHR) {
            		if (typeof data.nonconformance_level !== 'undefined') {
            			o._setNonconformance(data.nonconformance_level);
		            }
				}).fail(function(jqXHR, textStatus, errorThrown) {
					console.log('Could not check for nonconformance');
				});
			},

			_setNonconformance: function(level) {
            	if (!level) {
            		if (this.options.nonconformanceNag) {
			            clearInterval(this.options.nonconformanceNag);
			            this.options.nonconformanceNag = false;
		            }
	            } else {
            		this.options.nonconformanceNag = setInterval(function() {
            			var warningMessage = "<p>Please consider changing your current password, which does not conform to our security standards</p>";
            			warningMessage += "<p><a style='color:maroon' href='/user/account#security'>Click here to change your password</a></p>";
			            $("body").Vetology("vetologyShowDialog", "Warning:", warningMessage, "warning");
		            }, (4 - level) * 300000);
	            }
			},

            /*
             * vetology.vetology._acceptOCR
             *
             * @description	This method shows a confirmation dialog message, if confirmed then a callback function is called.
             *
             * @param String 	title		The title for the dialog
             * @param String 	message		The content of the dialog
             * @param Function 	callback	The callback function upon success
             *
             * @return NULL
             *
             */
            _acceptOCR: function(el){
            },

            /*
             * vetology.vetology._acceptOCR
             *
             * @description	This method shows a confirmation dialog message, if confirmed then a callback function is called.
             *
             * @param String 	title		The title for the dialog
             * @param String 	message		The content of the dialog
             * @param Function 	callback	The callback function upon success
             *
             * @return NULL
             *
             */
            _clearOCRScheduling: function(el){
                $('.datePickDOS').val('').removeAttr('disabled');
            },

            _savedProfile: function(item) {
                if (typeof item.json.changed_first_name !== 'undefined') {
                    const newName = item.json.changed_first_name;
                    const leftPanelName = document.querySelector('section.sidebar div.user-panel div.info p');
                    if (leftPanelName) {
                        const currentName = leftPanelName.textContent;
                        if (newName != currentName) {
                            leftPanelName.textContent = newName;
                        }
                    }

                    const rightNavbarName = document.querySelector('nav.navbar-static-top .navbar-custom-menu .navbar-nav li.user-menu a span');
                    if (rightNavbarName) {
                        const currentName = rightNavbarName.textContent;
                        if (newName != currentName) {
                            rightNavbarName.textContent = newName;
                        }
                    }
                }
                if (typeof item.json.errors !== 'undefined') {
                    if (typeof item.json.errors.first_name !== 'undefined') {
                        const elem = document.querySelector('input[name="first_name"]');
                        elem.setCustomValidity("Allowed Characters are alpha, dash, quote, space, period, comma, and diacritic characters");
                        elem.reportValidity();
                    }
                    if (typeof item.json.errors.last_name !== 'undefined') {
                        const elem = document.querySelector('input[name="last_name"]');
                        elem.setCustomValidity("Allowed Characters are alpha, dash, quote, space, period, comma, and diacritic characters");
                        elem.reportValidity();
                    }
                }
            },

            /*All below need to be cleaned up*/
        }
	);
	$(document).ready(function(){
		$("body").Vetology({});
	});
})(jQuery);

